<template>
  <div id="app">
    <div v-show="$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">{{$store.state.DLINE_ENVIRONMENT}}</div>
    <keep-alive :include="['GoodsList']">
        <!-- 需要缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
      <!-- 不需要缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      unionid:'',
    };
  },
  watch: {
    '$route': {
      handler(to, from){
        //console.log(to);
        //console.log(from);
        //console.log(this.$store.state.browser);
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
        }
      },
      immediate: true,//首次进入页面即执行
    },
  },
  created(){
    const _this = this;
    //unionid埋点
		if( _this.$store.state.browser.wx){
      if(!localStorage.getItem('unionid')){
        _this.unionid = _this.getUrlParam('unionid');
        localStorage.setItem('unionid', _this.unionid);
        _this.getUnionid();
      } else {
        _this.unionid = _this.getUrlParam('unionid');
        localStorage.setItem('unionid', _this.unionid);

      }

		}
  },
  methods: {
    //获取unionid
    getUnionid(){
      const _this = this;
      let local = window.location.href;
      window.location.replace("https://wechat.giant.com.cn/third/Oauth.aspx?username=giant&scope=snsapi_userinfo&redirect_uri="+encodeURIComponent(local)+"");
    },
    getUrlParam(name){
      var url = window.location.href;
      let params = url.substr(url.lastIndexOf("?") + 1).split("&");
      for (let i = 0; i < params.length; i++) {
        let param = params[i];
        let key = param.split("=")[0];
        let value = param.split("=")[1];
        if (key === name) {
          return value;
        }
      }
    },
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue